import DataAnnotation from "./DataAnnotation";

export default DataAnnotation;
